<template>
  <div>
    <div
      class="modal fade"
      id="modal-receipt-detail"
      data-keyboard="false"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" @click="onCloseModal()">
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">
              {{ $t("receipt.receiptDetail") }}
            </h4>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12">
                <div class="row">
                  <div class="col-md-6">
                    <label for="">{{ $t('receipt.receipt_code') }}: </label>
                    <span>{{ receiptData.receiptCode }}</span>
                  </div>
                  <div class="col-md-6">
                    <label for="">{{ $t('receipt.apartment_code') }}: </label>
                    <span>{{ receiptData.apartmentCode }}</span>
                  </div>
                  <div class="col-md-6">
                    <label for="">{{ $t('receipt.payer') }}: </label>
                    <span>{{ receiptData.payer }}</span>
                  </div>
                  <div class="col-md-6">
                    <label for="">{{ $t('receipt.monthlyCycle') }}: </label>
                    <span>{{ convertMonthlyCycle(receiptData.monthlyCycle) }}</span>
                  </div>
                  <div class="col-md-6">
                    <label for="">{{ $t('receipt.actual_amount_from_customer') }}: </label>
                    <span>{{ currencyFormat(receiptData.actualAmountFromCustomer) }}</span>
                  </div>
                  <div class="col-md-6">
                    <label for="">{{ $t('receipt.balance') }}: </label>
                    <span>{{ currencyFormat(receiptData.balance) }}</span>
                  </div>
                  <div class="col-md-6">
                    <label for="">{{ $t('receipt.user_created') }}: </label>
                    <span>{{ receiptData.userCreatedName }}</span>
                  </div>
                  <div class="col-md-6">
                    <label for="">{{ $t('receipt.fee_collection_date') }}: </label>
                    <span>{{ receiptData.feeCollectionDate }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <!-- <button
              type="button"
              class="btn btn-primary btn-sm pull-right"
              @click="onUpdateFeedbackProcessor()"
            >
              {{ $t("common.confirm") }}
            </button> -->
            <button
              type="button"
              class="btn btn-warning btn-sm pull-right"
              @click="onCloseModal()"
            >
              {{ $t("common.back") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex';
import utils from "@/lib/utils";
import i18n from "../../lang";
export default {
  data: () => ({
    receiptData: {
      id: null,
      receiptCode: null,
      apartmentCode: null,
      payer: null,
      actualAmountFromCustomer: null,
      balance: null,
      monthlyCycle: null,
      feeCollectionDate: null,
      userCreatedName: null
    }
  }),
  methods: {
    currencyFormat: function(value) {
      if (!utils.isEmptyString(value)) {
        return utils.formatNumber(value);
      }
      return null;
    },
    onCloseModal: function() {
      $("#modal-receipt-detail").modal("hide");
    },
    onShowProcessorModal: function() {
      $("#modal-receipt-detail").modal("show");
    },
    onShowReceiptDetail: function(receiptId) {
      this.getReceiptDetail(receiptId)
      this.onShowProcessorModal();
    },
    convertMonthlyCycle: function(monthlyCycleText) {
      // monthlyCycleText is 202105
      // ==> year: 2021, month: 05
      let month = ''
      let year = ''
      let results = ''
      if (!utils.isEmptyString(monthlyCycleText)) {
        let text = monthlyCycleText
        month = text.slice(4, 6)
        year = text.slice(0, 4)
        results = `${month}/${year}`
      }
      return results
    },
    getReceiptDetail: function(receiptId) {
      let data = {
        id: receiptId
      };
      this.GET_RECEIPT_DETAIL(data)
        .then(
          function(res) {
            this.receiptData.id = res.id
            this.receiptData.receiptCode = res.receipt_code
            this.receiptData.apartmentCode = res.apartment.apartment_code
            this.receiptData.payer = res.payer
            this.receiptData.actualAmountFromCustomer = res.amount
            this.receiptData.balance = res.balance
            this.receiptData.monthlyCycle = res.accounting_period
            let feeCollectionDate = utils.formatSqlDate(res.fee_collection_date, null, "DD/MM/YYYY");
            this.receiptData.feeCollectionDate = feeCollectionDate
            let user_created = utils.getFullName(res.user_first_name, res.user_last_name, i18n.locale);
            this.receiptData.userCreatedName = user_created
          }.bind(this)
        )
        .catch(
          function() {
            this.ERROR_TOAST();
          }.bind(this)
        );
    },
    ...mapActions([
      "GET_RECEIPT_DETAIL"
    ])
  }
};
</script>



// WEBPACK FOOTER //
// src/views/Receipt/ReceiptDetailModal.vue